// extracted by mini-css-extract-plugin
module.exports = {"toc-item":"table-of-contents_toc-item__K5mO_","indent":"table-of-contents_indent__wguNY"};